import React from 'react';
import Modal from '../../../../components/Modal';
import { Input, ValidationState } from '../../../../components/Forms';
import { Button, ButtonGroup } from '../../../../components/Buttons';
import { Formik } from 'formik';
import { WithTranslation, withTranslation } from 'react-i18next';
import { CustomerCompany } from '../types';

interface CompanyModalProps extends WithTranslation {
    company?: CustomerCompany;
    accountId: string;
    customerId: string;
    closeModal: () => void;
    saveCompany: (values: CustomerCompany) => void;
}

const EditCompanyModal = (
    {
        company,
        closeModal,
        saveCompany,
        t,
    }: CompanyModalProps
) => {
    const initialValues: CustomerCompany = {
        bussiness_name: company?.bussiness_name || '',
        organization_number: company?.organization_number || '',
        industry: company?.industry || '',
        department: company?.department || '',
        number_of_employees: company?.number_of_employees || '',
        website: company?.website || '',
    };

    return (
        <Modal>
            <Formik
                initialValues={initialValues as CustomerCompany}
                onSubmit={(values, { setSubmitting }) => {
                    saveCompany(values);
                    setSubmitting(false);
                }}
            >
                {({ values, errors, isSubmitting, handleChange, handleBlur, handleSubmit, touched }) => (
                    <form onSubmit={handleSubmit}>
                        <Input
                            autoComplete="off"
                            label={t('customers.customer.company.business_name')}
                            placeholder={t('customers.customer.company.business_name')}
                            type="text"
                            name="bussiness_name"
                            value={values.bussiness_name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            validation={{
                                state:
                                    errors.bussiness_name && touched.bussiness_name
                                        ? ValidationState.Invalid
                                        : ValidationState.Pristine,
                                message: errors.bussiness_name,
                            }}
                        />

                        <Input
                            autoComplete="off"
                            label={t('customers.customer.company.organization_number')}
                            placeholder={t('customers.customer.company.organization_number')}
                            type="text"
                            name="organization_number"
                            value={values.organization_number || ''}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />

                        <Input
                            autoComplete="off"
                            label={t('customers.customer.company.industry')}
                            placeholder={t('customers.customer.company.industry')}
                            type="text"
                            name="industry"
                            value={values.industry || ''}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />

                        <Input
                            autoComplete="off"
                            label={t('customers.customer.company.department')}
                            placeholder={t('customers.customer.company.department')}
                            type="text"
                            name="department"
                            value={values.department || ''}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />

                        <Input
                            autoComplete="off"
                            label={t('customers.customer.company.number_of_employees')}
                            placeholder={t('customers.customer.company.number_of_employees')}
                            type="text"
                            name="number_of_employees"
                            value={values.number_of_employees || ''}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />

                        <Input
                            autoComplete="off"
                            label={t('customers.customer.company.website')}
                            placeholder={t('customers.customer.company.website')}
                            type="text"
                            name="website"
                            value={values.website || ''}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />

                        <ButtonGroup>
                            <Button
                                type="submit"
                                disabled={isSubmitting}
                            >
                                {t('customers.customer.company.form.submit')}
                            </Button>

                            <Button
                                className="alt"
                                type="button"
                                onClick={() => closeModal()}
                            >
                                {t('customers.customer.company.form.close')}
                            </Button>
                        </ButtonGroup>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default withTranslation()(EditCompanyModal);
